/**
 * Hook: can the current user run the DAAily Drivers monthly board + release?
 *
 * Manager = app/hub admin OR super-admin OR the per-tool approver/approver_admin
 * role (`tools.drivers.role`). Mirrors the server-side `requireDriversManager`.
 * UI gating only.
 */
import { useProfile } from '../../profile/ProfileProvider';

export function useIsDriversManager(): boolean {
  const { state } = useProfile();
  if (state.status !== 'ready') return false;
  if (state.isAdmin) return true;
  if (state.user.hubRole === 'admin' || state.user.hubRole === 'super_admin') return true;
  const role = state.user.tools?.drivers?.role;
  return role === 'approver' || role === 'approver_admin';
}
